import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";

export const ORDER_INVALID_EVENT = "easybar-order-invalid";
function ValidationMessage({ messages, rtl, dismiss }: { messages: string[]; rtl: boolean; dismiss: () => void }) {
  const measure = () => ({ width: window.visualViewport?.width || window.innerWidth, height: window.visualViewport?.height || window.innerHeight });
  const [viewport, setViewport] = useState(measure);
  useEffect(() => {
    const update = () => setViewport(measure());
    window.visualViewport?.addEventListener("resize", update);
    window.addEventListener("resize", update);
    return () => { window.visualViewport?.removeEventListener("resize", update); window.removeEventListener("resize", update); };
  }, []);
  return <div dir={rtl ? "rtl" : "ltr"} style={{ display: "flex", alignItems: "flex-start", gap: 8, minWidth: 0, maxWidth: Math.max(120, viewport.width - 64), maxHeight: Math.max(80, viewport.height - 160), overflowY: "auto", overflowWrap: "anywhere" }}>
    <ul style={{ margin: 0, paddingInlineStart: 20, minWidth: 0 }}>{Array.from(new Set(messages)).map(message => <li key={message}>{message}</li>)}</ul>
    <button type="button" aria-label={rtl ? "סגירה" : "Close"} style={{ flex: "0 0 44px", minHeight: 44, minWidth: 44, color: "inherit", background: "transparent", border: 0, fontSize: 24 }} onClick={dismiss}>×</button>
  </div>;
}
export function showOrderValidation(messages: string[], field: string, rtl: boolean) {
  window.dispatchEvent(new CustomEvent(ORDER_INVALID_EVENT, { detail: { field } }));
  toast.error(notification => <ValidationMessage messages={messages} rtl={rtl} dismiss={() => toast.dismiss(notification.id)} />, {
    id: "order-validation", duration: 8000, position: "top-center",
    ariaProps: { role: "alert", "aria-live": "assertive" },
    style: { backgroundColor: "#fff1f2", color: "#9f1239", border: "1px solid #be123c", boxSizing: "border-box", maxWidth: "calc(100% - 24px)", marginTop: `max(${(window.visualViewport?.offsetTop || 0) + 56}px, env(safe-area-inset-top))` },
    iconTheme: { primary: "#be123c", secondary: "#fff" },
  });
}
